export default function EmailParser({ text }) {
  // Regular expression to match email addresses
  const emailRegex = /(\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b)/g;

  // Regular expression to match phone numbers
  const phoneRegex = /(\b\d{3}[-.]?\d{3}[-.]?\d{4}\b|\(\d{3}\) \d{3}-\d{4}\b)/g;

  // Extract email addresses, phone numbers, location, and id from the text
  const emails = text.match(emailRegex);
  const phones = text.match(phoneRegex);
  const location = text.match(/Location:\s*(.*)/);
  const id = text.match(/ID:\s*(.*)/);

  // Render the email addresses as list items
  const renderEmails = () => {
    if (!emails) return null;

    return emails.map((email) => (
      <li key={email}>
        Email: <a href={`mailto:${email}`}>{email}</a>
      </li>
    ));
  };

  // Render the phone numbers as list items
  const renderPhones = () => {
    if (!phones) return null;

    return phones.map((phone) => (
      <li key={phone}>
        Phone: <a href={`tel:${phone}`}>{phone}</a>
      </li>
    ));
  };

  // Render the location with a link to Google Maps
  const renderLocation = () => {
    if (!location) return null;

    const [, locationText] = location;
    const googleMapsLink = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
      locationText
    )}`;

    return (
      <li>
        Location:{" "}
        <a href={googleMapsLink} target="_blank" rel="noopener noreferrer">
          {locationText}
        </a>
      </li>
    );
  };

  const renderID = () => {
    if (!id) return null;

    const [, idText] = id;

    return <li>ID: {idText}</li>;
  };

  // Render the email, phone, and location lists
  return (
    <div>
      {id && <p>Please use My ID to make sure it&apos;s me!</p>}
      <ul>
        {renderID()}
        {renderEmails()}
        {renderPhones()}
        {renderLocation()}
      </ul>
    </div>
  );
}
